const directAccessConfigs = {
    vulcan: {
      directUrls: [
        '/en-US/directAccessToPureFibre',
        '/fr-CA/directAccessToPureFibre'
      ],
      webformUrls: {
        'en-US': '/en-US/vulcan/Vulcan_Landing_Page',
        'fr-CA': '/fr-CA/vulcan/Vulcan_Landing_Page'
      }
    },
    reports: {
      directUrls: [
        '/en-US/reports',
        '/fr-CA/reports',
        '/en-US/analytics',
        '/fr-CA/analytics'
      ],
      webformUrls: {
        'en-US': '/en-US/black-friday-reports',
        'fr-CA': '/fr-CA/black-friday-reports'
      }
    },
    vulcanPartner: {
      directUrls: [
        '/en-US/directAccessToPureFibrePartners',
        '/fr-CA/directAccessToPureFibrePartners'
      ],
      webformUrls: {
        'en-US': '/en-US/vulcan/Vulcan_Landing_Page',
        'fr-CA': '/fr-CA/vulcan/Vulcan_Landing_Page'
      },
      usePartnerSSO: true
    }
  };

export default directAccessConfigs;